export default __webpack_public_path__ + "static/media/DouglasLopes_05.513dd867.jpg";